import { useIsMobile } from "@/common/hooks/use-mobile";
import EntriesMobile from "../components/entries-mobile";
import useEntries from "../hooks/use-entries";
import EntriesTable from "./entries-table";
import SubscribeInsteadDialog from "./subscribe-instead-dialog";

function GetOneOffEntries() {
	const {
		entries,
		onEntrySelected,
		showSubscribeInsteadDialog,
		setShowSubscribeInsteadDialog,
		onProceedToEntryCheckout,
		onViewPlans,
	} = useEntries();

	const isMobile = useIsMobile();
	const styles = {
		background:
			"radial-gradient(58.09% 54.69% at 29.83% 2.93%, rgba(46, 219, 202, 0.30) 0%, rgba(8, 50, 46, 0.00) 100%), radial-gradient(301.04% 189.4% at 89.12% -41.16%, #2EDBCA 4.81%, #004096 43.8%, #470096 100%)",
		backgroundBlendMode: "plus-lighter, normal",
	};

	if (entries.length === 0) {
		return (
			<div
				style={styles}
				className="flex min-h-280 flex-col items-center justify-center gap-8 px-4 py-16 text-center md:gap-16 md:px-37 md:py-50"
			>
				<span className="web-heading-h2 text-white">
					This draw does not support one-off entries.
				</span>
				<p className="web-body-b1 text-white-80">
					Please check other draws or contact support for more information.
				</p>
			</div>
		);
	}

	return (
		<div
			style={styles}
			className="flex flex-col gap-8 px-4 py-16 text-center md:min-h-280 md:gap-16 md:px-37 md:py-50"
		>
			<div className="flex flex-col gap-6">
				<span className="web-heading-h2 text-white">
					Get <span className="text-green-300">One-off</span> entries
				</span>
				<p className="web-body-b1 text-white-80"> </p>
			</div>

			{isMobile ? (
				<EntriesMobile entries={entries} onSelect={onEntrySelected} />
			) : (
				<EntriesTable entries={entries} onSelect={onEntrySelected} />
			)}

			<SubscribeInsteadDialog
				open={showSubscribeInsteadDialog}
				onOpenChange={setShowSubscribeInsteadDialog}
				onProceedToEntry={onProceedToEntryCheckout}
				onViewPlans={onViewPlans}
			/>
		</div>
	);
}

export default GetOneOffEntries;
